import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '@mui/material/IconButton'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import type { GeblokkeerdeWeek } from '../types/GeblokkeerdeWeek'

export { GeblokkeerdeWeekTableRow }

type Props = {
  geblokkeerdeWeek: GeblokkeerdeWeek
  onRemove: (geblokkeerdeWeek: GeblokkeerdeWeek) => void
}

const GeblokkeerdeWeekTableRow = ({ geblokkeerdeWeek, onRemove }: Props) => {
  const { canCreateGeblokkeerdeWeek, organisatie } = useAuthenticatedUser()

  const canRemove =
    canCreateGeblokkeerdeWeek && geblokkeerdeWeek.organisatie === organisatie

  const handleRemove = () => {
    onRemove({ ...geblokkeerdeWeek, status: 'inactief' })
  }

  return (
    <TableRow>
      <TableCell>{geblokkeerdeWeek.organisatie}</TableCell>
      <TableCell>{geblokkeerdeWeek.week}</TableCell>
      <TableCell>
        {canRemove && (
          <Tooltip title="Verwijderen">
            <IconButton onClick={handleRemove}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </TableCell>
    </TableRow>
  )
}
